import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PartnerDataService } from './partner-data.service';
import { PartnerErrorHelper } from './partner-error-helper';
import { PartnerPortfolioDataService } from './partner-portfolio-data.service';
import { PartnerStoreHelper } from './partner-store-helper';

@NgModule({
	declarations: [],
	providers: [PartnerDataService, PartnerErrorHelper, PartnerStoreHelper, PartnerPortfolioDataService],
	imports: [CommonModule],
	exports: []
})
export class PartnerDataModule {}
